__turbopack_context__.v({
  "input": "ThemeToggle-module__4R_rJq__input",
  "legend": "ThemeToggle-module__4R_rJq__legend",
  "option": "ThemeToggle-module__4R_rJq__option",
  "optionLabel": "ThemeToggle-module__4R_rJq__optionLabel",
  "options": "ThemeToggle-module__4R_rJq__options",
  "wrap": "ThemeToggle-module__4R_rJq__wrap",
});
